module.exports = __webpack_public_path__ + "img/fournitures.a3135e33.png";